import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["inline", "children", "withCorner", "theme", "popoverContent", "alignText", "overflow", "increasedTouchZone", "direction", "minArrowOffset", "maxWidth", "hideOnTouchMove", "dataQaType", "variant", "customPadding", "cornerStyle", "pointerEvents", "portalTagName", "id", "onActiveToggle", "UNSAFE_className"],
  _excluded2 = ["tooltipStyle"];
import React, { useState } from 'react';
import { useId } from '@platform-ui/generateId';
import Popover from '@platform-ui/popover';
import Bubble from './TooltipBubble/TooltipBubble';
import { equalStyles } from './utils';
const Tooltip = _ref => {
  let {
      inline = false,
      children,
      withCorner = true,
      theme,
      popoverContent,
      alignText = 'left',
      overflow = 'visible',
      increasedTouchZone = false,
      direction: directionProp = 'bottom',
      minArrowOffset = 0,
      maxWidth = 288,
      hideOnTouchMove = true,
      dataQaType = 'uikit/tooltip',
      variant = 'desktop',
      customPadding = variant !== 'desktop' && withCorner ? 16 : 8,
      cornerStyle: propsCornerStyle,
      pointerEvents,
      portalTagName = 'span',
      id: propsId,
      onActiveToggle,
      UNSAFE_className
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [direction, setDirection] = useState('bottom');
  const [cornerStyle, setCornerStyle] = useState({});
  const [cornerRect, setCornerRect] = useState();
  const [borderRadius, setBorderRadius] = useState();
  const [borderRadiusStyle, setBorderRadiusStyle] = useState();
  const id = useId(propsId);
  const handleActiveToggle = (dir, cornStyle, _ref2) => {
    let {
        tooltipStyle
      } = _ref2,
      restArgs = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    if (direction !== dir || !equalStyles(cornerStyle, cornStyle)) {
      setDirection(dir);
      setCornerStyle(cornStyle);
      setBorderRadiusStyle(() => {
        const newStyles = {};
        for (const property of ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomLeftRadius', 'borderBottomRightRadius']) {
          if (tooltipStyle[property] === 0) {
            newStyles[property] = 0;
          } else {
            newStyles[property] = borderRadius;
          }
        }
        return newStyles;
      });
    }
    onActiveToggle == null || onActiveToggle(dir, cornStyle, _extends({
      tooltipStyle
    }, restArgs));
  };
  const bubble = popoverContent && /*#__PURE__*/React.createElement(Bubble, {
    dataQaType: `${dataQaType}.bubble`,
    inline: inline,
    withCorner: withCorner,
    direction: direction,
    cornerStyle: propsCornerStyle || cornerStyle,
    theme: theme,
    setCornerRect: setCornerRect,
    setBorderRadius: setBorderRadius,
    borderRadiusStyle: borderRadiusStyle,
    alignText: alignText,
    variant: variant,
    maxWidth: maxWidth,
    id: id,
    overflow: overflow
  }, popoverContent);
  return /*#__PURE__*/React.createElement(Popover, Object.assign({
    popoverBlock: bubble,
    onActiveToggle: handleActiveToggle,
    increasedTouchZone: increasedTouchZone,
    customPadding: customPadding,
    direction: directionProp,
    minArrowOffset: minArrowOffset,
    hideOnTouchMove: hideOnTouchMove
  }, otherProps, {
    role: "tooltip",
    dataQaType: dataQaType,
    arrowRect: cornerRect,
    arrowAdaptiveBorderRadiusValue: borderRadius,
    ariaDescribedBy: id,
    variant: variant,
    blockStyles: {
      pointerEvents
    },
    portalTagName: portalTagName,
    UNSAFE_className: UNSAFE_className
  }), children);
};
export default Tooltip;